<app-nav></app-nav>
<section class="healthInsurance" *ngIf="!quotesDetailsTable">
  <div class="container">
    <app-click-to-call></app-click-to-call>
    <div class="col">
      <form name="form" #f="ngForm">
        <center class="top-gap-sm">
          <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/fhi/fhi-main.jpg"
            width="30%" class="img-responsive ">
        </center>
        <center class="sub-title">
          <p>Get Quotes in One Simple Step</p>
        </center>
        <div class="col sum-container">
          <p class="title">Get Quote</p>
          <div class="age-input">
            <div class="input-group mb-3">
              <input type="text" id="age" name="age" class="form-control" placeholder="Enter Age of the Eldest Member"
                #age="ngModel" [(ngModel)]="familyAge" maxlength="2" (keydown.space)="$event.preventDefault();"
                (keyup)="checkZeroAsFirstInput($event);" pattern="[0-9]*" inputmode="numeric" required>
              <div class="input-group-append">
                <!-- <button class="btn btn-input-arrow" id="submitAge" type="submit" (click)="submitAge()" [disabled]="f.form.invalid"></button>   -->
                <button class="btn btn-input-arrow" id="submitAge" type="submit" (click)="submitAgeDetails()"
                  [disabled]="f.form.invalid"></button>
              </div>
            </div>
          </div>
          <div *ngIf="shouldBe18" class="error-message">
            Age should be greater than 18.
          </div>
          <div *ngIf="shouldBe60" class="error-message">
            Age should not be greater than 60.
          </div>
        </div>
        <div *ngIf="age.invalid && age.touched " class="error-message text-center">
          <div *ngIf="age.errors.required">
            Age is required.
          </div>
          <div *ngIf="age.errors.pattern && !zeroNotAllow">
            Invalid Age.
          </div>
        </div>
        <div *ngIf="zeroNotAllow" class="error-message text-center">
          Invalid Age. Can't start with 0.
        </div>
        <div *ngIf="invalidAgeError" class="error-message text-center">
          Invalid Age.
        </div>
        <div *ngIf="zeroNotAllow" class="error-message text-center">
          Invalid Age. Can't start with 0.
        </div>
      </form>
      <div class="col text-center top-gap-xs">

        <h6 class="mt-2 text-center" style="
        text-align: center!important;
        margin: 0 auto;
        margin-bottom: 15px;font-weight: 600;
    ">INSURERS</h6>
        
        <div class="row insurer-logo">
         
          <div class="col-md-4 col-sm-12">
            
            <img class="care-health"
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/careLogo.png">
          </div>
          <div class="col-md-4 col-sm-12 insure_logoes">
            
            <img
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/RoyalSundaramLogo.png">
          </div>
          <div class="col-md-4 col-sm-12 insure_logoes">
           
            <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/insurers/united-india-logo.png">
          </div>
        </div>
        <!-- <div class="row insurer-logo">
          <div class="col top-gap-sm bottom-gap-md">
            <img
              src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/max-bupa.png">
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <div class="footer-bar">
    <span><b><u>Fill Info</u></b></span><span class="next-step-icon"></span><span>Quote Page</span>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>
<section class="healthInsurance-quote-details" *ngIf="quotesDetailsTable">
  <div class="breadcrumbs text-center">
    <span routerLink="/home">Home</span>
    <span routerLink="/family-health-insurance">Health Insurance</span>
    <span>Quote</span>
  </div>
  <div class="proposed-limit-section">
    <p class="heading">Proposed Quote</p>
    <p class="sub-heading">Sum Insured</p>
    <select class="form-control" class="form-control" [(ngModel)]="selectedSumInsured"
      (change)="getQuoteDetails(); getQuoteDetailsForCare()">
      <option value="1 Lakh">1 Lac</option>
      <option value="2 Lakhs" selected>2 Lacs</option>
      <option value="3 Lakhs">3 Lacs</option>
      <option value="5 Lakhs" selected>5 Lacs</option>
      <option value="10 Lakhs">10 Lacs</option>
      <option value="20 Lakhs">20 Lacs</option>
      <option value="50 Lakhs">50 Lacs</option>
    </select>
  </div>
  <div class="proposed-limit-section">
    <p class="sub-heading">Family Size</p>
    <div class="">
      <label class="container fam-check">Self
        <input type="checkbox" name="self" value="self" disabled checked="checked">
        <span class="checkmark"></span>
      </label>
      <label class="container fam-check">Spouse
        <input type="checkbox" name="spouse" value="spouse" [(ngModel)]="spouseSelected"
          (change)="getFamilySize(childSize)">
        <span class="checkmark"></span>
      </label>
      <label class="container fam-check" *ngFor="let child of childsList"> {{child}} Kid
        <input type="checkbox" name="child" id="{{child}}" value="{{child}}" [(ngModel)]="childSize"
          (change)="getFamilySize(child);">
        <span class="checkmark"></span>
      </label>
      <!-- <label class="container fam-check">1 Child
        <input type="radio" id="5" name="1 child" value="1 child" (change)="getFamilySize($event)" [checked]="childCount == 1 ? true : false">
        <span class="checkmark"></span>
      </label>
      <label class="container fam-check">2 Child
        <input type="checkbox" name="2 child" value="2 child" (change)="getFamilySize($event)">
        <span class="checkmark"></span>
      </label> -->
    </div>

  </div>
  <!-- Care Health -->
  <div class="proposed-limit-section">
  <div class="quote-summary">
    <div class="insurer-logo">
      <div class="logo-links">
        <img class="care-health-logo"
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/careLogo.png " class="img-responsive subnission_image1">
      </div>
      <!-- <span>Essential Cover</span> -->
    </div>
    <div class="premium-details">
      <div class="premium-amount d-flex">
        <div class="p-2 mr-auto">
          <p class="title">Total Premium</p>
          <p class="sub-title">(INR,Excluding Taxes)</p>
        </div>
        <div class="p-2">
          <span class="rupees-symbol">&#8377;</span><span
            class="amount">{{careQuoteDetails.XLEW_2_6_3 == null ? 'NA' : careQuoteDetails.XLEW_2_6_3 | number : '1.0-0'}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="col p-2 d-flex">
            <button class="btn-bordered-blue mr-auto collapsed" data-toggle="collapse"
              data-target="#detailed-section-care">
              <span class="if-collapsed"></span>
            </button>
            <button class="btn-filled-orange pull-right" [disabled]="careQuoteDetails.XLEW_2_6_3 == null"
              (click)="createProspect(); selectInsurer('careHealth');">Buy Now</button>
          </div>
        </div>
      </div>
      <div id="detailed-section-care" class="collapse">
        <div class="quote-section">
          <div class="premium-summary p-2">
            <p class="title">
              Inclusions
            </p>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Cover Type
                <!-- <span class="help-icon">
                  <img src="assets/images/help-icon.png" tooltip="Treatment of COVID" />
                </span> -->
              </span>
            </div>
            <div class="right-box">
              <span>Individual</span>
              <!-- <icon class="right"></icon> -->
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Family Definition</span>
            </div>
            <div class="right-box">
              <span>{{familySize}}</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Sum Insured</span>
            </div>
            <div class="right-box">
              <span>{{selectedSumInsured}}</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>In-patient care
                <!-- <span class="help-icon">
                <img src="assets/images/help-icon.png" tooltip="Any related medical costs that were incurred before the patient got hospitalized." />
              </span> -->
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Day Care Treatment
                <!-- <span class="help-icon">
                <img src="assets/images/help-icon.png" tooltip="Any related medical costs that are incurred after the patient gets discharged after hospital treatment." />
              </span> -->
                <icon class="right"></icon>
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Normal Room Rent Charges
                <!-- <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="For each claim-free year, the No Claim Bonus increases the policy value (sum insured) by 20%, going up to a maximum of 100% over the original value." />
                </span> -->
              </span>
            </div>
            <div class="right-box">
              <span>{{roomRentSI}}</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>ICU Room Charges
                <!-- <span class="help-icon">
                <img src="assets/images/help-icon.png" tooltip="This benefit that reinstates the total sum assured by upto 100% if it is fully used up in any given policy year." />
              </span> -->
              </span>
            </div>
            <div class="right-box">
              <span>{{icuCharges}}</span>
              <!-- <icon class="right"></icon> -->
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Pre-hospitalization Medical expenses
              </span>
            </div>
            <div class="right-box">
              <span>30 days</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Post-hospitalization Medical expenses
              </span>
            </div>
            <div class="right-box">
              <span>60 days</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Domestic Road Ambulance
              </span>
            </div>
            <div class="right-box">
              <span>Up to Rs.2500 per hospitalization</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Network Hospitals Covered
              </span>
            </div>
            <div class="right-box">
              <span>8350+</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No Copay
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Pre-existing Disease Waiting Period
              </span>
            </div>
            <div class="right-box">
              <span>1 Year</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>30 Days Waiting Period
                <!-- <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="The prescribed period of time you will have to wait before you are covered for hospitalisation and treatment for specified ailments like Non-infective Arthritis, Cataract, etc." />
                </span> -->
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Waiting Period on Specific Diseases
                <!-- <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Annual health check-ups available free to holders of the policy." />
                </span> -->
              </span>
            </div>
            <div class="right-box">
              <span>1 Year</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <div class="premium-summary p-2">
                <p class="title">
                  Health Services
                </p>
              </div>
              <!-- <b> -->
              <!-- <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Hospitals in which the insurer will directly bear your treatment cost." />
                </span> -->
              <!-- </b> -->
            </div>
            <div class="right-box">
              <!-- <icon class="right"></icon> -->
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Doctor on Call
                <!-- <span class="help-icon">
                  <img src="assets/images/help-icon.png" tooltip="Ayurveda, Yoga, Unani, Siddha, and Homeopathy" />
                </span> -->
              </span>
            </div>
            <div class="right-box">
              <span>Covered the only GP</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Discount Connect
                <!-- <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Selected treatments that do not require 24-hour hospitalization." />
                </span> -->
              </span>
            </div>
            <div class="right-box">
              <span>Covered</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <div class="premium-summary p-2">
                <p class="title">
                  Conditions
                </p>
              </div>
            </div>
            <div class="right-box">
              <!-- <icon class="right"></icon> -->
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Quote valid for fresh case
                <!-- <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="The insurer has to renew the policy as long as you are alive and pay  your premiums on time." />
                </span> -->
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Filled Up Proposal Form</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No hospitalization in the last year</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="note">
            <p>NOTE:INSURANCE IS THE SUBJECT MATTER OF SOLICITATION.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <!-- Care Health -->
  <div class="proposed-limit-section">
  <div class="quote-summary">
    <div class="insurer-logo">
      <div class="logo-links">
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/RoyalSundaramLogo.png">
      </div>
      <!-- <span>Comprehensive Cover</span> -->
    </div>
    <div class="premium-details">
      <div class="premium-amount d-flex">
        <div class="p-2 mr-auto">
          <p class="title">Total Premium</p>
          <p class="sub-title">(INR,Excluding Taxes)</p>
        </div>
        <div class="p-2">
          <span class="rupees-symbol">&#8377;</span><span
            class="amount">{{quoteDetails.XLEW_2_21_5 == 0 ? 'NA' : quoteDetails.XLEW_2_21_5 | number : '1.0-0'}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="col p-2 d-flex">
            <button class="btn-bordered-blue mr-auto collapsed" data-toggle="collapse"
              data-target="#detailed-section-royal">
              <span class="if-collapsed"></span>
            </button>
            <button class="btn-filled-orange pull-right" [disabled]="quoteDetails.XLEW_2_21_5 == 0"
              (click)="createProspect(); selectInsurer('royalSundaram');">Buy Now</button>
          </div>
        </div>
      </div>
      <div id="detailed-section-royal" class="collapse">
        <div class="quote-section">
          <div class="premium-summary p-2">
            <p class="title">
              Inclusions
            </p>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>COVID 19 Coverage
                <span class="help-icon">
                  <img src="assets/images/help-icon.png" tooltip="Treatment of COVID" />
                </span>
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Room Rent Limit</span>
            </div>
            <div class="right-box">
              <span>Normal & ICU in any room category - No Limit</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Hospitalisation Expenses with minimum of 24 hours of Hospitalisation</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Pre hospitalisation expenses
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Any related medical costs that were incurred before the patient got hospitalized." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <span>60 days</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Post hospitalisation expenses
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Any related medical costs that are incurred after the patient gets discharged after hospital treatment." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <span>90 days</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No-Claim bonus
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="For each claim-free year, the No Claim Bonus increases the policy value (sum insured) by 20%, going up to a maximum of 100% over the original value." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <span>20% of Base Sum Insured upto a max of 100%</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Restoration Benefit(Reload of sum insured)
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="This benefit that reinstates the total sum assured by upto 100% if it is fully used up in any given policy year." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No Copay
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="The insurer will pay all admissible charges without any deduction" />
                </span>
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Pre-Existing Diseases Waiting Period
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Waiting period for diseases which are declared by the policyholder at the time of policy purchase." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <span>3 Years</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Specific Diseases Waiting Period
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="The prescribed period of time you will have to wait before you are covered for hospitalisation and treatment for specified ailments like Non-infective Arthritis, Cataract, etc." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <span>2 Years</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Free Annual Health Check up
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Annual health check-ups available free to holders of the policy." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Network Hospitals Covered
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Hospitals in which the insurer will directly bear your treatment cost." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <span>4195</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>AYUSH Treatment
                <span class="help-icon">
                  <img src="assets/images/help-icon.png" tooltip="Ayurveda, Yoga, Unani, Siddha, and Homeopathy" />
                </span>
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Day Care Procedures
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="Selected treatments that do not require 24-hour hospitalization." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <span>All Day Care Procedures covered</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Ambulance Charges</span>
            </div>
            <div class="right-box">
              <span>Upto Rs 5000</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Life Long Renewability
                <span class="help-icon">
                  <img src="assets/images/help-icon.png"
                    tooltip="The insurer has to renew the policy as long as you are alive and pay  your premiums on time." />
                </span>
              </span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Tax Benefits</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>





          <!-- <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Sum Insured</span>
            </div>
            <div class="right-box">
              <span>{{quoteDetails.XLEW_2_7_4}}</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Cover Opted for</span>
            </div>
            <div class="right-box">
              <span>{{quoteDetails.XLEW_2_8_4}}</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Cashless Facility</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Lifetime Renewability</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Pre and Post hospitalisation expenses</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Day-care Surgeries</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No claim-based loading</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No Co-Pay</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No sub-limits on room rent</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Lower waiting period for pre-existing diseases (i.e. less than 4 years)</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div> -->
          <div class="note">
            <p>NOTE : THESE ARE INDICATIVE PRICES. INSURANCE IS THE SUBJECT
              MATTER OF SOLICITATION.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <!-- <div class="quote-summary">
    <div class="insurer-logo">
        <div class="logo-links">
          <div id="addOnSlider" class="carousel slide" data-ride="carousel" data-interval="false">
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/star-health-white-bg.png"> 
              </div>
              <div class="carousel-item">
                <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/careLogo.png">
              </div>
            </div>
            <a class="carousel-control-prev" href="#addOnSlider" data-slide="prev">
              <span class="carousel-control-prev-icon"></span>
            </a>
            <a class="carousel-control-next" href="#addOnSlider" data-slide="next">
              <span class="carousel-control-next-icon"></span>
            </a>
          </div>
      </div>
      <span>With limited add-ons</span>
    </div>
    <div class="premium-details">
      <div class="premium-amount d-flex">
        <div class="p-2 mr-auto">
          <p class="title">Total Premium</p>
          <p class="sub-title">(INR,Excluding Taxes)</p>
        </div>
        <div class="p-2">
          <span class="rupees-symbol">&#8377;</span><span class="amount"></span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="col p-2 d-flex">
            <button class="btn-bordered-blue mr-auto collapsed" data-toggle="collapse" data-target="#detailed-section-religare">
              <span class="if-collapsed"></span>
            </button>
            <button class="btn-filled-orange pull-right" (click)="initiatePayment(quoteDataUnitedIndia);">Buy Now</button>
          </div>
        </div>
      </div>
      <div id="detailed-section-religare" class="collapse">
        <div class="quote-section">
          <div class="premium-summary p-2">
            <p class="title">
              Inclusions
            </p>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Coves Opted for</span>
            </div>
            <div class="right-box">
              <span>Self & Spouce</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Cashless Facility</span>
            </div>
            <div class="right-box">
              <span></span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Lifetime Renewability</span>
            </div>
            <div class="right-box">
              <span>1:1</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Pre and Post hospitalisation expenses</span>
            </div>
            <div class="right-box">
              <span></span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Day-care Surgeries</span>
            </div>
            <div class="right-box">
              <span></span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No claim-based loading</span>
            </div>
            <div class="right-box">
              <span></span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No Co-Pay</span>
            </div>
            <div class="right-box">
              <span></span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No sub-limits on room rent</span>
            </div>
            <div class="right-box">
              <span></span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Lower waiting period for pre-existing diseases (i.e. less than 4 years)</span>
            </div>
            <div class="right-box">
              <span></span>
            </div>
          </div>
          <div class="note">
            <p>NOTE : THESE ARE INDICATIVE PRICES. INSURANCE IS THE SUBJECT
                MATTER OF SOLICITATION.</p>
          </div>
        </div>
      </div>
    </div>
  </div>-->

 
    <div class="proposed-limit-section">


  <div class="quote-summary">
    <div class="insurer-logo">
      <div class="logo-links">
        <img
          src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/united-india-logo.png">
      </div>
      <!-- <span>Basic Cover</span> -->
    </div>
    <div class="premium-details">
      <div class="premium-amount d-flex">
        <div class="p-2 mr-auto">
          <p class="title">Total Premium</p>
          <p class="sub-title">(INR,Excluding Taxes)</p>
        </div>
        <div class="p-2">
          <span class="rupees-symbol">&#8377;</span><span
            class="amount">{{quoteDetails.XLEW_2_21_11 == 0 ? 'NA' : quoteDetails.XLEW_2_21_11 | number : '1.0-0'}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="col p-2 d-flex">
            <button class="btn-bordered-blue mr-auto collapsed" data-toggle="collapse"
              data-target="#detailed-section-star">
              <span class="if-collapsed"></span>
            </button>
            <button class="btn-filled-orange pull-right" [disabled]="quoteDetails.XLEW_2_21_11 == 0"
            (click)="createProspect('unitedIndia');selectInsurer('unitedIndia');openProspectModal(templateThankyou);">Buy Now</button>

          </div>
        </div>
      </div>
      <div id="detailed-section-star" class="collapse">
        <div class="quote-section">
          <div class="premium-summary p-2">
            <p class="title">
              Inclusions
            </p>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Sum Insured</span>
            </div>
            <div class="right-box">
              <span>{{quoteDetails.XLEW_2_7_4}}</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Cover Opted for</span>
            </div>
            <div class="right-box">
              <span>{{quoteDetails.XLEW_2_8_4}}</span>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Cashless Facility</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Lifetime Renewability</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Pre and Post hospitalisation expenses</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Day-care Surgeries</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No claim-based loading</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No Co-Pay</span>
            </div>
            <div class="right-box">
              <icon class="right"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No sub-limits on room rent</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>No sub-limits for specific diseases and expense</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Minimum 10% No-Claim bonus</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
          </div>
          <div class="d-flex premium-detailed-summary">
            <div class="left-box">
              <span>Lower waiting period for pre-existing diseases (i.e. less than 4 years)</span>
            </div>
            <div class="right-box">
              <icon class="cross"></icon>
            </div>
          </div>
          <div class="note">
            <p>NOTE : Insurance is the subject matter of solicitation.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>

<!-- <ng-template #template>
  <form name="form" #prospectForm="ngForm">
    <div class="modal-body" id="contactInfoModal">
      <div class="col">
        <span class="modal-title">Contact Info</span>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="col sum-container">
        <p class="title mt-4 mendatory">Name</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text" name="name" id="name" #name="ngModel" [(ngModel)]="propspect.name"
              pattern="[a-zA-Z\s]+" maxlength="200" required>
          </div>
        </div>
      </div>
      <div class="col">
        <div *ngIf="name.invalid && name.touched " class="error-message">
          <div *ngIf="name.errors.required">
            Name is required.
          </div>
          <div *ngIf="name.errors.pattern">
            Please enter valid name.
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4 mendatory">Mobile No.</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text" name="mobile" id="mobile" #mobile="ngModel"
              [(ngModel)]="propspect.mobile" maxlength="10" minlength="10" (keydown.space)="$event.preventDefault();"
              pattern="^((?!(0))[0-9]{1,10}\d*)$" inputmode="numeric" required>
          </div>
        </div>
      </div>
      <div class="col">
        <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
          <div *ngIf="mobile.errors.required">
            Mobile number is required.
          </div>
          <div *ngIf="mobile.errors.minlength && !mobile.errors.pattern">
            Mobile number must be at least 10 digits long.
          </div>
          <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
            Invalid mobile number.
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4 mendatory">City</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input type="text" class="form-control city-input" [typeahead]="cityList"
              (typeaheadOnSelect)="selectCity($event)" (focusout)="checkCityValue($event)" [isAnimated]="true"
              #city="ngModel" name="city" [(ngModel)]="contactCity" placeholder="City" maxlength="50" required />
          </div>
        </div>
      </div>
      <div class="col">
        <div *ngIf="city.invalid && city.touched " class="error-message">
          <div *ngIf="city.errors.required && !noResult">
            City is required.
          </div>
        </div>
        <div *ngIf="noResult" class="error-message">No results found!</div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4 mendatory">E-mail Address</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text" name="email" id="email" #email="ngModel"
              [(ngModel)]="propspect.email" [email]="true" required>
          </div>
        </div>
      </div>
      <div class="col">
        <div *ngIf="email.invalid && email.touched " class="error-message">
          <div *ngIf="email.errors.required">
            Email Address is required.
          </div>
          <div *ngIf="email.errors.email">
            Please enter correct Email address.
          </div>
        </div>
      </div>
      <div class="col sum-container">
        <p class="title mt-4">Coupon Code (Optional)</p>
        <div class="sum-insured-input">
          <div class="form-group">
            <input class="form-control" type="text" maxlength="50" [(ngModel)]="propspect.coupon" name="coupon">
          </div>
        </div>
      </div>
      <div class="col text-center mt-4">
        <button class="btn btn-bordered-blue" aria-label="Close" [disabled]="prospectForm.invalid || noResult"
          (click)="modalRef.hide();createProspect()">Next</button>
      </div>
    </div>
  </form> -->
  <!-- <div class="modal-header">
      <div class="col">
        <h4 class="modal-title title left">Contact Details</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <div class="modal-body">
      <form name="form" #prospectForm="ngForm">
        <div class="form-group">
          <input type="text" class="form-control" name="name" [(ngModel)]="propspect.name" placeholder="Name" required />
        </div>
        <div class="form-group">
            <input type="text" class="form-control city-input" [typeahead]="cityList" (typeaheadOnSelect)="selectCity($event)" (focusout)="checkCityValue($event)"
            [isAnimated]="true" #city="ngModel" name="city" [(ngModel)]="propspect.location"
              placeholder="City" maxlength="50" required />
        </div>
        <div class="form-group">
          <input type="text" class="form-control" name="mobile" [(ngModel)]="propspect.mobile" placeholder="Mobile" required />
        </div>
        <div class="form-group">
          <input type="text" class="form-control" name="email" [(ngModel)]="propspect.email" placeholder="Email" required />
        </div>
        <div class="form-group">
          <input type="text" class="form-control" name="coupon" [(ngModel)]="propspect.coupon" placeholder="Coupan Code" />
        </div>
      </form>
      <div class="col text-center mt-4">
        <button class="btn btn-bordered-blue" aria-label="Close"
          (click)="modalRef.hide();createProspect();" [disabled]="!prospectForm.valid">Next</button>
      </div>
    </div> -->
<!-- </ng-template> -->

<ng-template #templateThankyou>
  <form name="form" #prospectForm="ngForm">
    <div class="modal-body" id="contactInfoModal">
      <div class="row text-center">
        <div class="col-12">
          <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-12">
          <h4 class="thankyou-heading">Thank You</h4>
          <hr>
          <p>We will call you back soon within 24 hours.</p>
        </div>
      </div>
    </div>
  </form>
</ng-template>
